export const MuiButtonGroup = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      boxShadow: 'none',
    },
    grouped: {
      border: 'none !important',
    },
  },
}
